import { Action, createReducer, on } from '@ngrx/store';
import { Actualities } from '@features/dashboard/mes-actualites/models/actualities.model';
import * as ActualitiesActions from '@features/dashboard/mes-actualites/stores/actualities.actions';

export interface ActualitiesState {
  actualities: Actualities[];
  loading: boolean;
  error: any;
}

export const initialState: ActualitiesState = {
  actualities: [],
  loading: false,
  error: null,
};

const _actualitiesReducer = createReducer(
  initialState,
  on(ActualitiesActions.loadActualities, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(ActualitiesActions.loadActualitiesSuccess, (state, { actualities }) => ({
    ...state,
    loading: false,
    actualities
  })),
  on(ActualitiesActions.loadActualitiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export function actualitiesReducer(state: ActualitiesState | undefined, action: Action): ActualitiesState {
  return _actualitiesReducer(state, action);
}

export { ActualitiesState as State };
